import { selectBlockParent } from '@octopus-do/octopus-project-core'
import {
  type HydratedBlock,
  useGetHydratedBlocks,
} from '@store/migrationSelectors/blocks'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

const useBlocks = () => {
  const { getHydratedBlocks } = useGetHydratedBlocks()

  const blocks = getHydratedBlocks()

  return useSelector((state: AppState) => {
    return blocks.map((block) => {
      const nodeId = selectBlockParent(block.id)(state)[0]

      // @todo broken search in block notes

      return {
        ...block,
        nodeId,
      }
    }) as HydratedBlock[]
  })
}

export default useBlocks
